import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { PrimaryButton } from '@components/button/primary-button/primary-button';
import { ExternalSceneRowViewModel } from '../../external-scenes/external-scenes.models';
import { resolveActionState } from '../../external-scenes/external-scenes-view.util';

/**
 * The "Load LRSD" button of one scene: enabled only while the row can be loaded, otherwise a disabled button
 * labelled with the row's state. Shared by the table row and the Quick View dialog so both always agree.
 */
@Component({
  selector: 'app-external-scene-action',
  standalone: true,
  templateUrl: './external-scene-action.component.html',
  styleUrl: './external-scene-action.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PrimaryButton]
})
export class ExternalSceneActionComponent {
  readonly row = input.required<ExternalSceneRowViewModel>();
  /** Emits the row id when the enabled button is pressed. */
  readonly loadClick = output<string>();

  readonly state = computed(() => resolveActionState(this.row()));

  onAction(): void {
    const row = this.row();
    if (row.canLoad && !row.isLoading) {
      this.loadClick.emit(row.id);
    }
  }
}
